import { render } from "./StatsHalfDoughnut.vue?vue&type=template&id=c6dc1a52&scoped=true"
import script from "./StatsHalfDoughnut.vue?vue&type=script&lang=js"
export * from "./StatsHalfDoughnut.vue?vue&type=script&lang=js"

import "./StatsHalfDoughnut.vue?vue&type=style&index=0&id=c6dc1a52&scoped=true&lang=css"

import exportComponent from "D:\\Pragmasoft\\zntry.consent\\src\\Zntry.Consent.Website\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6dc1a52"]])

export default __exports__